enum Theme {
    light = 'light',
    dark = 'dark',
};

export default Theme;
